import React, { useContext } from 'react';
import Navbar from '../../Shared/Navbar/Navbar';
import './Header.css'
import { Link, useHistory } from 'react-router-dom';
import Nature from '../../../resources/images/plants 1.png'
import { LanguageContext } from '../../../Contexts/LanguageContext';

const Header = () => {
    const history = useHistory()
    const [isBangla, setIsBangla] = useContext(LanguageContext)

    return (
        <div className='header'>
            <div className="header-con">
                <Navbar />
                <div className="container">
                    <div className="row mt-3 d-flex justify-content-center align-items-center">
                        <div className="col-md-8 header-text">
                            <div className="container">
                                <h1 className="back-to-nature-text">{isBangla ? "প্রকৃতিতে ফিরে যাই" : "Back To The Nature"}</h1>
                                <h2 className="love-nature-text">{isBangla ? "প্রকৃতিকে ভালোবাসি" : "Love The Nature"}</h2>
                                <a className="all-products-btn" href="/products">{isBangla ? "সকল পণ্যগুলো দেখুন" : "See All Products"}</a>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="container header-img-box">
                                <img src={Nature} alt="" />
                                <h2>{isBangla ? "ঔষধ এখন সহজ" : "Medicines Made Easy"}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;